
import {Modal } from "antd";
import SupportModule from "./SupportModule";

export function ModalSupport({
  closeFn,
  visible,
}: {
  visible: boolean;
  closeFn: () => void;
}) {
  

  return (
    <Modal
      title="Precisa de Ajuda?"
      visible={visible}
      onCancel={() => closeFn()}
      closable={true}
      footer={null}
    >
   <SupportModule closeFn={closeFn} />
    </Modal>
  );
}
